import { getI18n } from 'react-i18next';
import { userConstants } from '../constants/user.constants';
import { userService } from '../../services/login';
import { adminService } from '../../services/admin';
import { alertActions } from './alert.actions';
import { history } from '../../utils/history';

export const userActions = {
  login,
  logout,
  findUserById,
  updateEmail,
  changePassword,
  resetPassword,
  setPractitionerProductSub,
  loginAsUser,
};

function login({
  username,
  password,
  type = 'basic',
  accessToken,
  refreshToken,
}) {
  return (dispatch) => {
    dispatch(request({ username, password }));
    return userService
      .login({ username, password, type, accessToken, refreshToken })
      .then(
        (user) => {
          dispatch(success(user.data));
          history.push('/admin/dashboard');
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(getI18n().t('errors.login.failed')));
        },
      );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }

  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }

  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function updateEmail({ email, newEmail, password }) {
  return (dispatch) => {
    dispatch(request());
    return userService.updateEmail({ email, newEmail, password }).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        const errMessage = error?.response?.data?.error?.message;

        if (errMessage)
          dispatch(
            alertActions.error(
              getI18n().t(`errors.update.email.${errMessage}`),
            ),
          );
        dispatch(failure());
        throw new Error(error);
      },
    );
  };

  function request() {
    return { type: userConstants.UPDATE_EMAIL_REQUEST };
  }

  function success() {
    return { type: userConstants.UPDATE_EMAIL_SUCCESS };
  }

  function failure() {
    return { type: userConstants.UPDATE_EMAIL_FAILURE };
  }
}

function logout(queryParam = null) {
  return (dispatch) => {
    userService.logout();
    let searchPath = '/login';
    if (queryParam) {
      searchPath = { pathname: '/login', search: queryParam };
    }
    history.push(searchPath);
    dispatch({ type: userConstants.LOGOUT });
  };
}

function changePassword(data) {
  return (dispatch) => {
    dispatch({ type: userConstants.CHANGE_PASSWORD });
    return userService.changePassword(data);
  };
}

function resetPassword(data, token) {
  return (dispatch) => {
    dispatch({ type: userConstants.RESET_PASSWORD });
    return userService.resetPassword(data, token);
  };
}

function findUserById(id) {
  return (dispatch) => {
    dispatch(request({ id }));

    return userService.findUserById(id).then(
      (user) =>
        userService.getRole(id).then(
          (result) => {
            const newUser = user.data;
            newUser.roleName = result.data[0].roleName;
            dispatch(success(newUser));
          },
          (error) => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
          },
        ),
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      },
    );
  };

  function request(user) {
    return { type: userConstants.GET_REQUEST, user };
  }

  function success(user) {
    return { type: userConstants.GET_SUCCESS, user };
  }

  function failure(error) {
    return { type: userConstants.GET_FAILURE, error };
  }
}

function setPractitionerProductSub(isActiveSub) {
  return {
    type: userConstants.SET_PRACTITIONER_PRODUCT_SUB,
    payload: { isActiveSub },
  };
}

function loginAsUser(userId) {
  return (dispatch) => {
    dispatch(request({ userId }));

    return adminService.loginAsUser(userId).then(
      (response) => {
        userService.logout();
        dispatch(success(response));
        history.push('/admin/dashboard');
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error('Failed to login as user'));
      },
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }

  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }

  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}
